import { mapActions, mapGetters } from "vuex";
import { maxLength, required } from "vuelidate/lib/validators";
import validation from "@/mixins/validation";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/uk";
import multiselect from "@/components/@ui/multiselect/index.vue";

const typeOfActivityList = [
  { key: 'beauty_salon_studio', title: 'Салон краси/студія' },
  { key: 'network_salon', title: 'Мережевий салон' },
  { key: 'beauty_clinic', title: 'Клініка краси' },
  { key: 'network_clinic', title: 'Мережева клініка' },
  { key: 'online_store', title: 'Інтернет-магазин' },
  { key: 'physical_store', title: 'Фізичний магазин' },
  { key: 'dealer', title: 'Дилер' },
  { key: 'masseur', title: 'Масажист' },
  { key: 'doctor', title: 'Лікар' },
  { key: 'dermatologist', title: 'Дерматолог' },
  { key: 'aesthetic_medicine_doctor', title: 'Лікар естетичної медицини' },
  { key: 'private_practice_cosmetologist', title: 'Приватний кабінет - косметолог' },
  { key: 'cosmetologist_injection_nurse', title: 'Косметолог-ін’єкціоніст' },
]

export default {
  name: "user-data",
  data() {
    return {
      typeOfActivityList: { ...typeOfActivityList },
      payload: {
        secondName: "",
        name: "",
        lastName: "",
        country: "",
        city: "",
        work: "",
        birth_date: null,
        // typeOfActivity: null,
        // typeOfActivityList: null,
      },

      isEdit: false,
      validationErrors: {},
    };
  },
  mixins: [validation],
  validations() {
    const payload=  {
      name: {
        required,
        maxLength: maxLength(191),
      },
      secondName: {
        required,
        maxLength: maxLength(191),
      },
      lastName: {
        maxLength: maxLength(191),
      },
      country: {
        maxLength: maxLength(191),
      },
      city: {
        maxLength: maxLength(191),
      },
      birth_date: {
      },
    }

    // if (this.isProfessional) {
    //   payload.typeOfActivity = {
    //     required,
    //   }
    // }
    if (this.isProfessional || this.isDistributor) {
      payload.work = {
        maxLength: maxLength(191),
      }
    }

    return { payload }
  },
  components: {
    DatePicker,
    multiselect
  },
  computed: {
    ...mapGetters({
      user: "profile/user",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      updateUserLoading: "profile/updateUserLoading",
    }),
    typeOfActivityText() {
      if (this.user?.typeOfActivity) {
        const payloadTypeOfActivity = this.user.typeOfActivity.split(',')
        return payloadTypeOfActivity
            .map(item => {
              return typeOfActivityList.find(e => e.key === item ).title
            })
            .join(', ')
      }
      return ''
    },
    typeOfActivityValueList() {
      if (this.user?.typeOfActivity) {
        const payloadTypeOfActivity = this.user.typeOfActivity.split(',')
        return payloadTypeOfActivity
            .map(item => {
              return typeOfActivityList.find(e => e.key === item ).title
            })
      }
      return []
    },
    secondNameErrors() {
      return this.computeErrors("payload", "secondName", {
        required: "validationRequired",
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    nameErrors() {
      return this.computeErrors("payload", "name", {
        required: "validationRequired",
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    lastNameErrors() {
      return this.computeErrors("payload", "lastName", {
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    countryErrors() {
      return this.computeErrors("payload", "country", {
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    cityErrors() {
      return this.computeErrors("payload", "city", {
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    addressErrors() {
      return this.computeErrors("payload", "work", {
        maxLength: { message: "validationMax", count: 191 },
      });
    },
    birthDateErrors() {
      return this.computeErrors("payload", "birth_date", {
      });
    },
    // typeOfActivityErrors() {
    //   return this.computeErrors('payload', 'typeOfActivity', {
    //     required: 'validationRequired',
    //   })
    // },
  },
  watch: {
    user(newVal) {
      if (newVal) {
        if (this.user) this.setUserInfo();
      }
    },
  },
  created() {
    if (this.user) this.setUserInfo();
  },
  methods: {
    ...mapActions({
      updateUserData: "profile/UPDATE_USER_DATA",
      login: "auth/GET_TOKEN",
    }),
    handleSelectTypeOfActivity(value) {
      this.payload.typeOfActivity = value.map((item) => item.title)
      this.payload.typeOfActivityList = value
    },
    resetForm() {
      this.isEdit = false;
      this.$v.$reset();
      this.setUserInfo();
    },
    setUserInfo() {
      this.payload.secondName = this.user.secondName;
      this.payload.name = this.user.name;
      this.payload.lastName = this.user.lastName;
      this.payload.country = this.user.country;
      this.payload.city = this.user.city;
      if (this.user.birthDate) {
        const inputDate = new Date(this.user.birthDate);
        this.payload.birth_date = inputDate;
      } else {
        this.payload.birth_date = null;
      }
      if (this.user.work) this.payload.work = this.user.work;
      if (this.user.typeOfActivity) {
        if (Array.isArray(this.user.typeOfActivity)) {
          this.payload.typeOfActivity = this.user.typeOfActivity
        }
        else if (typeof this.user.typeOfActivity === 'string') {
          this.payload.typeOfActivity = this.user.typeOfActivity.split(',')
        } else {
          this.payload.typeOfActivity = []
        }
      }
    },
    update() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        let obj = {};
        obj.name = this.payload.name;
        obj.second_name = this.payload.secondName;
        obj.last_name = this.payload.lastName;
        obj.country = this.payload.country;
        obj.city = this.payload.city;
        // if (this.payload.typeOfActivity) {
        //   obj.type_of_activity = this.payload.typeOfActivityList.map(item => item.key).join(',')
        // }

        if (this.payload.birth_date) {
          let date = new Date(this.payload.birth_date);
          obj.birth_date = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
            .format(date)
            .replaceAll("/", ".");
        } else {
          obj.birth_date = null;
        }

        if (this.isProfessional || this.isDistributor) obj.work = this.payload.work;
        this.updateUserData(obj)
          .then(() => {
            this.$toasted.success(this.$t("successResetData"));
            this.isEdit = false;
          })
          .catch(error => {
            const message = error.data?.message;
            if (message) {
              this.$toasted.error(message);
            }
          });
      }
    },
  },
};
